var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractIconWrapper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_294_6109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_294_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7873 14.2102C17.693 14.1159 17.6194 14.007 17.5666 13.8835C17.5134 13.7595 17.4867 13.6386 17.4867 13.5207L17.4867 9.13667C17.4867 8.8774 17.5869 8.64759 17.7873 8.44724C17.9876 8.24689 18.2174 8.14672 18.4767 8.14672C18.736 8.14672 18.9658 8.24689 19.1661 8.44724C19.3665 8.64759 19.4666 8.8774 19.4666 9.13667L19.4666 12.5308L22.8607 12.5308C23.12 12.5308 23.3498 12.631 23.5502 12.8313C23.7505 13.0317 23.8507 13.2615 23.8507 13.5207C23.8507 13.78 23.7505 14.0098 23.5502 14.2102C23.3498 14.4105 23.12 14.5107 22.8607 14.5107L18.4767 14.5107C18.3353 14.5107 18.2087 14.484 18.097 14.4308C17.9848 14.378 17.8815 14.3044 17.7873 14.2102ZM8.15293 18.4705C8.15293 18.2112 8.2531 17.9814 8.45345 17.7811C8.65379 17.5807 8.8836 17.4805 9.14288 17.4805L13.5269 17.4805C13.6684 17.4805 13.7949 17.5072 13.9067 17.5604C14.0188 17.6132 14.1221 17.6868 14.2164 17.7811C14.3106 17.8753 14.3872 17.9816 14.4462 18.1C14.5051 18.2173 14.5287 18.3408 14.5169 18.4705L14.5169 22.8899C14.5169 23.1492 14.4167 23.3729 14.2164 23.5609C14.016 23.75 13.7862 23.8445 13.5269 23.8445C13.2677 23.8445 13.0379 23.7443 12.8375 23.544C12.6372 23.3436 12.537 23.1138 12.537 22.8545V19.4604H9.14288C8.8836 19.4604 8.65379 19.3603 8.45345 19.1599C8.2531 18.9596 8.15293 18.7298 8.15293 18.4705Z",
    fill: "#3D3D3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIconWrapper);
export default __webpack_public_path__ + "static/media/contract-icon-wrapper.7c5a9040119a42ef25696188f002c291.svg";
export { ForwardRef as ReactComponent };